'use client'

// src/components/plans/BenefitTitle.tsx
import { ExclamationIcon } from "@wbk/svg";
import { Tooltip } from "@wbk/ui";
import { jsx, jsxs } from "react/jsx-runtime";
var BenefitTitle = ({ benefit, icon, description }) => {
  if (!(benefit == null ? void 0 : benefit.name)) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    Tooltip,
    {
      open: !description && benefit.description ? void 0 : false,
      content: /* @__PURE__ */ jsx("div", { className: "text-xs", dangerouslySetInnerHTML: { __html: benefit.description || "" } }),
      children: /* @__PURE__ */ jsxs("li", { className: "flex gap-3", children: [
        icon && /* @__PURE__ */ jsx(
          "img",
          {
            src: benefit.icon,
            width: 24,
            height: 24,
            alt: `${benefit.name} icon`,
            className: "mt-px h-6 w-6 shrink-0"
          }
        ),
        /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("p", { className: `benefit-title ${!description && benefit.description ? "underline" : ""}`, children: benefit.name }),
          description && benefit.description && /* @__PURE__ */ jsx(
            "p",
            {
              className: "text-text-secondary",
              dangerouslySetInnerHTML: { __html: benefit.description }
            }
          )
        ] }),
        benefit.description && !description && /* @__PURE__ */ jsx("span", { className: "text-text lg:hidden ltr:ml-auto rtl:mr-auto", children: /* @__PURE__ */ jsx(ExclamationIcon, {}) })
      ] })
    }
  );
};
var BenefitTitle_default = BenefitTitle;

// src/components/plans/BenefitsList.tsx
import { twMerge } from "tailwind-merge";
import { useTranslation } from "@wbk/config";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var BenefitsList = ({ benefits, description, riyadhSeason, className }) => {
  const { t } = useTranslation(["subscription_common"]);
  if (!benefits)
    return null;
  return /* @__PURE__ */ jsxs2("ul", { className: twMerge("w-full space-y-4", className), children: [
    !!riyadhSeason && /* @__PURE__ */ jsx2(
      BenefitTitle_default,
      {
        benefit: {
          name: t("subscription_common:riyadh_season.benefit_title"),
          description: description ? t("subscription_common:riyadh_season.benefit_description") : void 0,
          icon: "/@wbk/subscription/season/riyadh_season.svg"
        },
        description,
        icon: true
      }
    ),
    benefits.map((benefit) => {
      return /* @__PURE__ */ jsx2(BenefitTitle_default, { benefit, description, icon: true }, benefit._id);
    })
  ] });
};
var BenefitsList_default = BenefitsList;

export {
  BenefitTitle_default,
  BenefitsList_default
};
//# sourceMappingURL=chunk-UYKLOVAV.mjs.map